// extracted by mini-css-extract-plugin
export var authorName = "ReviewSection-module--authorName--92b5b";
export var container = "ReviewSection-module--container--42871";
export var contentWrap = "ReviewSection-module--contentWrap--21d87";
export var icon = "ReviewSection-module--icon--06fb6";
export var imageRight = "ReviewSection-module--imageRight--cd943";
export var imageWrap = "ReviewSection-module--imageWrap--03ade";
export var section = "ReviewSection-module--section--d1bf4";
export var stores = "ReviewSection-module--stores--7381a";
export var text = "ReviewSection-module--text--e6ecd";